<template>
  <div class="container ime-3-by-6-by-3">
    <div class="row">
      <div class="col-sm-12 col-md-3">
        <div class="row">
          <slot name="slot1"></slot>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="row">
          <slot name="slot2"></slot>
        </div>
      </div>
      <div class="col-sm-12 col-md-3">
        <div class="row">
          <slot name="slot3"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThreeBySixByThree",
}
</script>

<style lang="scss" scoped>
  .ime-3-by-6-by-3 {

  }
</style>